import _toConsumableArray from "/var/jenkins_home/workspace/mka-pc_prod/node_modules/@babel/runtime/helpers/toConsumableArray.js";
import _objectSpread from "/var/jenkins_home/workspace/mka-pc_prod/node_modules/@babel/runtime/helpers/objectSpread2.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { debounce } from 'throttle-debounce';
export default {
  props: {
    url: {
      type: String,
      default: ''
    },
    reqType: {
      type: String,
      default: 'apiGet'
    },
    params: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    'query-key': {
      type: String,
      default: ''
    },
    'value-key': {
      type: String,
      default: ''
    },
    'value-label': {
      type: String,
      default: ''
    },
    json: {
      type: Boolean,
      default: false
    },
    defOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    value: {
      type: [String, Number, Object],
      default: ''
    },
    type: {
      type: String,
      default: 'autocomplete'
    }
  },
  data: function data() {
    return {
      data: '',
      options: [],
      pages: {
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      loading: false
    };
  },
  watch: {
    value: {
      handler: function handler(val) {
        this.data = val;
      },
      immediate: true
    },
    defOptions: {
      handler: function handler(val) {
        this.options = Object.freeze(val);
      },
      immediate: true
    },
    data: function data(val) {
      this.$emit('input', val);
    }
  },
  computed: {},
  created: function created() {
    if (this.type == 'select') {
      this.getItem();
    }
  },
  mounted: function mounted() {},
  methods: {
    querySearch: debounce(1000, function (queryString, cb) {
      this.pages.pageNum = 1;
      this.$set(this.params, this.queryKey, queryString);
      this.getItem(false, cb);
    }),
    handleScroll: function handleScroll() {
      if (!this.loading) {
        if (this.pages.pageNum * this.pages.pageSize < this.total) {
          this.pages.pageNum += 1;
          this.getItem(true);
        }
      }
    },
    getItem: function getItem(e) {
      var _this = this;
      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
      this.loading = true;
      this[this.reqType](this.url, _objectSpread(_objectSpread({}, this.pages), this.params)).then(function (res) {
        if (res.data.content == undefined) {
          res.data.content = res.data;
        }
        if (e) {
          if (_this.type != 'select') {
            var _this$$refs$autocompl;
            (_this$$refs$autocompl = _this.$refs['autocomplete'].$data.suggestions).push.apply(_this$$refs$autocompl, _toConsumableArray(res.data.content));
          } else {
            var _this$options;
            (_this$options = _this.options).push.apply(_this$options, _toConsumableArray(res.data.content));
          }
        } else {
          cb(res.data.content);
          _this.options = res.data.content;
          _this.total = res.data.total;
        }
        _this.loading = false;
      });
    },
    onChange: function onChange(e) {
      var _this2 = this;
      if (!this.json) {
        var option = {};
        this.options.forEach(function (item) {
          if (e == item[_this2.valueKey]) {
            option = _objectSpread({}, item);
          }
        });
        this.$emit('change', option);
      } else {
        this.$emit('change', e);
      }
    }
  }
};